export const OrderStatusBadge = ({ status }) => {
  const map = {
    "Delivered":  "bg-green-50 text-green-700 border-green-200",
    "On the Way": "bg-blue-50 text-blue-700 border-blue-200",
    "Preparing":  "bg-amber-50 text-amber-700 border-amber-200",
    "Cancelled":  "bg-red-50 text-red-600 border-red-200",
  };
  return <span className={`text-xs font-bold px-2.5 py-1 rounded-full border ${map[status]||"bg-gray-100 text-gray-600"}`}>{status}</span>;
};